import script from "./Settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./Settings.vue?vue&type=script&lang=ts&setup=true"

import "./Settings.vue?vue&type=style&index=0&id=0e68a62a&lang=scss&scoped=true"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e68a62a"]])

export default __exports__